import { runtimeConfig } from '@/config/runtime'

export const buildApiUrl = () => {
  const baseUrl = runtimeConfig.apiUrl || ''
  const port = runtimeConfig.apiPort || ''
  const version = runtimeConfig.apiVersion || ''

  // Start with the base URL and remove trailing slash if it exists
  let url = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl

  // Add port if it exists
  if (port && port !== '0') {
    url = `${url}:${port}`
  }

  // Add version if it exists
  if (version) {
    url = `${url}/${version}`
  }

  // Add trailing slash if it doesn't exist
  if (!url.endsWith('/')) {
    url += '/'
  }

  return url
}
